import styles from './TitleSection.module.css';
import logo from '../../../../assets/images/event/seniorhelper-logo.png';

function TitleSection() {
  return (
    <section className={styles.section}>
      <p className={styles.catchphrase}>라파엘노인데이케어센터 후원</p>
      <p className={styles.serviceNameBlack}>어르신 전용 심부름센터</p>
      <img src={logo} alt="시니어헬퍼" className={styles.logoImg} />
      <p className={styles.eventName}>무료이벤트</p>
    </section>
  );
}

export default TitleSection;
